import type { IconVariantTypes } from "../../shared-components/css-modules/toyota/atoms/Icon.types";
import type { IconVariantTypes as lexusIconTypes } from "../../shared-components/css-modules/lexus/atoms/Icon.types";

export enum GradeSelectorFilterId {
    Engine = "engine",
    Price = "price",
    Sort = "sort",
    WheelDrive = "wheelDrive",
    Transmission = "transmission",
    Colour = "colour",
    PopularFeatures = "popularFeatures",
}

type filterConfigType = {
    id: GradeSelectorFilterId;
    icon: IconVariantTypes | lexusIconTypes;
};

export const GradeSelectorFilterConfig: filterConfigType[] = [
    {
        id: GradeSelectorFilterId.Engine,
        icon: "engine",
    },
    {
        id: GradeSelectorFilterId.WheelDrive,
        icon: "wheelDrive",
    },
    {
        id: GradeSelectorFilterId.Transmission,
        icon: "transmission",
    },
    {
        id: GradeSelectorFilterId.Colour,
        icon: "colour",
    },
    {
        id: GradeSelectorFilterId.Price,
        icon: "finance",
    },
    {
        id: GradeSelectorFilterId.Sort,
        icon: "sort-2",
    },
    {
        id: GradeSelectorFilterId.PopularFeatures,
        icon: "wrench",
    },
];

export const multipleChoiceFilterIds = [GradeSelectorFilterId.Colour, GradeSelectorFilterId.PopularFeatures] as const;

export type MultipleChoiceFilterIdType = (typeof multipleChoiceFilterIds)[number];

export const isMultipleChoiceFilter = (filterId: GradeSelectorFilterId): filterId is MultipleChoiceFilterIdType => {
    return multipleChoiceFilterIds.includes(filterId as MultipleChoiceFilterIdType);
};

export enum SortingType {
    CashPriceAsc = "cash-ascending",
    CashPriceDesc = "cash-descending",

    WltpAsc = "wltp-ascending",
    WltpDesc = "wltp-descending",

    FuelEfficiencyAsc = "FuelEfficiency-ascending",
    FuelEfficiencyDesc = "FuelEfficiency-descending",
}
